export default __webpack_public_path__ + "static/media/enterprise.bg.d6c63fa1.svg";